import * as _ from 'underscore';
import { Sparkline, SparklineWithTitle } from '../../app/content/Sparkline';
import { IPopoverScope } from '../directives/tbPopover';
import { L10n } from '../L10n/L10n';
import { IItemStatisticsInfo, IStatsTimeSeriesInfo } from '../models/resourceInfoParts';
import { Module } from '../Module';
import { IUsageInfo } from '../ServerApi/types/IUsageInfo';
import { SelectedDetailedItemScope } from './ContentSubplaceCtrl';

export interface IContentItemPopoverScope extends SelectedDetailedItemScope<any, any>, IPopoverScope {
  item: any; // Inherited from the ng-repeat scope in thumbnails.pug
  $location: ng.ILocationService;
  sparklineWithTitleProps: SparklineWithTitle.Props;
  browserSupportForSparkline: boolean;
}

export class ContentItemPopoverCtrl {

  public static $inject = ['$scope', '$location', '$translate'];

  constructor($scope: IContentItemPopoverScope, $location: ng.ILocationService,
      $translate: ng.translate.ITranslateService) {
    $scope.$location = $location;
    $scope.browserSupportForSparkline = Sparkline.browserSupportForSparkline();

    const visibleWatch =
      $scope.$watch('visible', (visible: boolean) => {
        if (visible) {

          // HACK: We use a row-based layout for the item details "table", which keeps each row's
          // label and value aligned vertically regardless of the row's height. In order to keep the
          // columns aligned (and avoid CSS table-cell), we find the width of the widest label (left
          // column) and then apply that width to all the label cells in that column.
          const DetailLabelCellClass = '.tb-content-item-popover-label';
          const detailLabelWidth = _.max(_.map($(DetailLabelCellClass), (el) => $(el).width()));
          $(DetailLabelCellClass).width(detailLabelWidth);

          const defaultSparklineProps = {
            title: $translate.instant('metric_hitsTotal_sparklineTitle', {
                  COUNT: (<IItemStatisticsInfo<IUsageInfo>>$scope.item).usageInfo.hitsTotal
              }, L10n.Interpolations.Count),
            caption: $translate.instant('metric_hitsTotal_sparklineCaption'),
            sparklineProps: {
              dataPoints: <number[]>[],
              width: 274,     // content popover width minus its padding (from popover.styl / contentPopover.styl)
              height: 66
            }
          };

          $scope.sparklineWithTitleProps = defaultSparklineProps;

          $scope.getItemDetails($scope.item).then(detailedItem => {
            $scope.detailedItem = detailedItem;
            $scope.sparklineWithTitleProps = _.clone(defaultSparklineProps); //to trigger props update
            $scope.sparklineWithTitleProps.sparklineProps.dataPoints =
                (<IStatsTimeSeriesInfo>detailedItem).hitsTimeSeries;
          });

          // Deregister the 'visible' watch, since we only want to fetch
          // the item details once.
          visibleWatch();
        }
      });

  }
}

Module.instance().controller('ContentItemPopoverCtrl', ContentItemPopoverCtrl);
